/* eslint-disable prefer-destructuring */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { cloneDeep } from 'lodash';

import PopOverMenu from '../../PopOverMenu';
import { formatMatchDateWithOffset } from '../../../utils/formatting';
import Popup from '../../Popup';
import withAuth from '../../hocs/withAuth';
import * as actions from '../../../actions/post-score-actions';
import BackgroundImage from '../../BackgroundImage';
import PlayerSelectComponent from '../CardComponents/PlayerSelect';
import DoublesPlayerSelectComponent from '../CardComponents/DoublesPlayerSelect';
import DisplayScoreComponent from '../CardComponents/DisplayScore';
import { showErrorPopup } from '../../../actions/notification-actions';

const _ = { cloneDeep };

class DualMatchCardEdit extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showDeletePopUp: false,
        };
        this.onSelected = this.onSelected.bind(this);
        this.handlePostScore = this.handlePostScore.bind(this);
        this.playerSelect = this.playerSelect.bind(this);
        this.teamSelect = this.teamSelect.bind(this);
    }

    onSelected(menuOption, ev) {
        switch (menuOption.id) {
            case 'edit_score':
                this.handlePostScore();
                break;
            case 'resend_invites':
                this.props.resendInvites(this.props.matchObj.result.id);
                break;
            case 'delete_score':
                this.setState({
                    showDeletePopUp: true,
                });
                break;
            case 'accept_score':
                this.props.acceptOrRejectScore(this.props.matchObj.result.id, 'accept');
                break;
            case 'reject_score':
                this.props.acceptOrRejectScore(this.props.matchObj.result.id, 'reject');
                break;
            case 'delete_match':
                this.props.handleDeleteMatch(this.props.gameType === 'singles' ? this.props.singlesDraw.id : this.props.doublesDraw.id, this.props.matchObj.id);
                break;
            default:
                this.props.onSelected(menuOption, ev);
                break;
        }
    }

    validateTeamsDataToPostScore = () => {
        const { matchObj, gameType, teamsDict, playersDict } = this.props;
        let validTeamsData = true;

        if (gameType === 'doubles') {
            const team1 = teamsDict[matchObj.position1.id];
            const team2 = teamsDict[matchObj.position2.id];
            if (!!team1 && !!team2) {
                const team1player1 = playersDict[team1.players[0]];
                const team1player2 = playersDict[team1.players[1]];
                const team2player1 = playersDict[team2.players[0]];
                const team2player2 = playersDict[team2.players[1]];
                validTeamsData = team1player1 && team1player2 && team2player1 && team2player2;
            } else {
                validTeamsData = false;
            }
            return validTeamsData;
        }
        return validTeamsData;
    };

    playerSelect(position, player) {
        const { matchObj, singlesDraw } = this.props;
        // console.log('playerSelect', matchObj[position] && matchObj[position].id, player && player.id)
        if (!matchObj[position] || !player || matchObj[position].id !== player.id) {
            this.props.handlePlayerSelect(singlesDraw.id, matchObj.id, position, {
                type: 'player',
                players: player && player.id ? [player.id] : null,
            });
        }
    }

    teamSelect(position, team) {
        const { matchObj, doublesDraw } = this.props;
        if (!matchObj[position] || !team || matchObj[position].id !== team.id) {
            this.props.handleTeamSelect(doublesDraw.id, matchObj.id, position, team);
        }
    }

    handlePostScore() {
        const { matchObj, singlesDraw, doublesDraw, gameType } = this.props;
        let selectedDrawId; let
            matchIndex;
        if (gameType === 'singles') {
            selectedDrawId = singlesDraw.id;
            matchIndex = singlesDraw.rounds[0].matches.map(e => e.id).indexOf(matchObj.id);
        } else {
            selectedDrawId = doublesDraw.id;
            matchIndex = doublesDraw.rounds[0].matches.map(e => e.id).indexOf(matchObj.id);
        }
        if (!!matchObj.position1 && !!matchObj.position2 && this.validateTeamsDataToPostScore()) {
            this.props.handlePostScore(selectedDrawId, matchIndex);
        } else {
            this.props.showErrorPopup('You must select players before posting the score.', null);
        }
    }

    handlePlayerSelectClick() {
        this.props.showErrorPopup('Blabla.', null);
    }

    render() {
        const {
            index,
            matchObj,
            playersDict = {},
            teamsDict = {},
            teams = [],
            team1Players = [],
            team2Players = [],
            singlesDraw,
            doublesDraw,
            utrType,
            gameType,
            eventTeams,
            eventDate,
            disablePostScoreButton,
            sportTypeId,
            'data-testid': dataTestId,
        } = this.props;

        const {
            players,
            forceCardView,
            force,
            date,
        } = matchObj.result || {};

        const hasResult = matchObj.result !== null;
        const { isSaving } = matchObj;

        const menuOptions = this.props.menuOptions ? this.props.menuOptions : [{
            id: 'delete_match',
            label: 'Delete Match',
            value: 'delete_match',
        }];
        // if (actions && actions.edit && actions.edit.allowed && (!clubIds || (clubIds.length == 0) || clubProfilePage)) {
        if (matchObj.result) {
            menuOptions.push({
                id: 'edit_score',
                label: 'Edit Score',
                value: 'edit_score',
            });
        }
        // TODO: Non-working code, there are no action objects exported.
        // if (actions && actions.delete && actions.delete.allowed && (!clubIds || (clubIds.length === 0) || clubProfilePage)) {
        //     menuOptions.push({
        //         id: 'delete_score',
        //         label: 'Delete Score',
        //         value: 'delete_score',
        //     });
        // }
        // if (actions && actions.resendInvite && actions.resendInvite.allowed) {
        //     menuOptions.push({
        //         id: 'resend_invites',
        //         label: 'Resend Invites',
        //         value: 'resend_invites',
        //     });
        // }
        const desktopMenuOptions = _.cloneDeep(menuOptions);
        // if (actions && actions.reject && actions.reject.allowed) {
        //     desktopMenuOptions.splice(0, 0, {
        //         id: 'reject_score',
        //         label: 'Deny',
        //         value: 'Deny',
        //     });
        // }
        // if (actions && actions.accept && actions.accept.allowed) {
        //     desktopMenuOptions.splice(0, 0, {
        //         id: 'accept_score',
        //         label: 'Confirm',
        //         value: 'Confirm',
        //     });
        // }

        let team1; let
            team2;
        if (eventTeams[0] && eventTeams[1]) {
            if (!eventTeams[0].isHome) {
                team1 = eventTeams[0];
                team2 = eventTeams[1];
            } else {
                team1 = eventTeams[1];
                team2 = eventTeams[0];
            }
        }

        return (
            <React.Fragment>
                <div className={`utr-card dual-match-card dual-match-card-edit ${hasResult ? 'has-score' : 'no-score'} ${isSaving ? 'show-overlay' : ''} `}>
                    <div className={`${forceCardView || (force && force.cardView) ? 'd-block' : 'd-block d-md-none'}`}>
                        <div className="card-view">
                            <div className="header">
                                <div className="rank" data-testid={dataTestId && `${dataTestId}.mobile.rank`}>{index}</div>
                                <div className="flex-2">
                                    {gameType === 'singles'
                                        ? (
                                            <div className="players-wrapper">
                                                <div className="player-input">
                                                    {team1 && (
                                                        <BackgroundImage
                                                            baseUrl={'/v1/club/'}
                                                            defaultImage={'/img/utr-ball--teal.svg'}
                                                            images={team1.clubProfileImages}
                                                            imageType={'profile'}
                                                            parentStylesClass={'team-logo'}
                                                        />
                                                    )}
                                                    <PlayerSelectComponent
                                                        drawFormatType={singlesDraw.drawFormatType}
                                                        match={matchObj}
                                                        playerOptions={team1Players}
                                                        playersDict={playersDict}
                                                        utrType={utrType}
                                                        allowPlayerChange={true}
                                                        showBye={false}
                                                        position="position1"
                                                        onSelect={this.playerSelect}
                                                        showTeamName={true}
                                                        teamName={team1.isCollege ? (team1.shortName || team1.displayName) : team1.displayName}
                                                        warnBeforePlayerChange={matchObj.result ? 'Changing a player will reset the scores.' : false}
                                                        sportTypeId={sportTypeId}
                                                        data-testid={dataTestId && `${dataTestId}.mobile.singles-position1-player-select`}
                                                    />
                                                </div>
                                                <div className="player-input">
                                                    {team2 && (
                                                        <BackgroundImage
                                                            baseUrl={'/v1/club/'}
                                                            defaultImage={'/img/utr-ball--teal.svg'}
                                                            images={team2.clubProfileImages}
                                                            imageType={'profile'}
                                                            parentStylesClass={'team-logo'}
                                                        />
                                                    )}
                                                    <PlayerSelectComponent
                                                        drawFormatType={singlesDraw.drawFormatType}
                                                        match={matchObj}
                                                        playerOptions={team2Players}
                                                        playersDict={playersDict}
                                                        utrType={utrType}
                                                        allowPlayerChange={true}
                                                        showBye={false}
                                                        position="position2"
                                                        onSelect={this.playerSelect}
                                                        showTeamName={true}
                                                        teamName={team2.isCollege ? (team2.shortName || team2.displayName) : team2.displayName}
                                                        warnBeforePlayerChange={matchObj.result ? 'Changing a player will reset the scores.' : false}
                                                        sportTypeId={sportTypeId}
                                                        data-testid={dataTestId && `${dataTestId}.mobile.singles-position2-player-select`}
                                                    />
                                                </div>
                                            </div>
                                        )
                                        : (
                                            <div className="players-wrapper">
                                                <DoublesPlayerSelectComponent
                                                    drawFormatType={doublesDraw.drawFormatType}
                                                    match={matchObj}
                                                    playerOptions={team1Players}
                                                    playersDict={playersDict}
                                                    teamsDict={teamsDict}
                                                    teams={teams}
                                                    clubProfileImages={team1 && team1.clubProfileImages}
                                                    utrType={utrType}
                                                    allowPlayerChange={true}
                                                    showBye={false}
                                                    position="position1"
                                                    onSelect={this.teamSelect}
                                                    showTeamName={true}
                                                    teamName={team1.isCollege ? (team1.shortName || team1.displayName) : team1.displayName}
                                                    warnBeforePlayerChange={matchObj.result ? 'Changing a player will reset the scores.' : false}
                                                    sportTypeId={sportTypeId}
                                                    data-testid={dataTestId && `${dataTestId}.mobile.doubles-position1-player-select`}
                                                />
                                                <DoublesPlayerSelectComponent
                                                    drawFormatType={doublesDraw.drawFormatType}
                                                    match={matchObj}
                                                    playerOptions={team2Players}
                                                    playersDict={playersDict}
                                                    teamsDict={teamsDict}
                                                    teams={teams}
                                                    clubProfileImages={team2 && team2.clubProfileImages}
                                                    utrType={utrType}
                                                    allowPlayerChange={true}
                                                    showBye={false}
                                                    position="position2"
                                                    onSelect={this.teamSelect}
                                                    showTeamName={true}
                                                    teamName={team2.isCollege ? (team2.shortName || team2.displayName) : team2.displayName}
                                                    warnBeforePlayerChange={matchObj.result ? 'Changing a player will reset the scores.' : false}
                                                    sportTypeId={sportTypeId}
                                                    data-testid={dataTestId && `${dataTestId}.mobile.doubles-position2-player-select`}
                                                />
                                            </div>
                                        )}
                                </div>
                                <div className={`flex-1 text-right`}>
                                    {hasResult
                                        ? (
                                            <React.Fragment>
                                                <DisplayScoreComponent match={matchObj} position="position1" playersDict={playersDict} teamsDict={teamsDict} data-testid={dataTestId && `${dataTestId}.mobile.position1-score`} />
                                                <DisplayScoreComponent match={matchObj} position="position2" playersDict={playersDict} teamsDict={teamsDict} data-testid={dataTestId && `${dataTestId}.mobile.position2-score`} />
                                            </React.Fragment>
                                        )
                                        : (
                                            <button
                                                type="button"
                                                className="btn btn-default btn-small mr16"
                                                disabled={disablePostScoreButton}
                                                onClick={this.handlePostScore}
                                                data-testid={dataTestId && `${dataTestId}.mobile.score-btn`}
                                            >
                                                Score
                                            </button>
                                        )}
                                </div>
                            </div>
                            <div className="footer d-flex jcsb">
                                <div className="flex-column date-round">
                                    <div data-testid={dataTestId && `${dataTestId}.mobile.event-date`}>{eventDate}</div>
                                    <div data-testid={dataTestId && `${dataTestId}.mobile.team-name`}>{team2.name}</div>
                                </div>
                                <div className="options-container align-self-center">
                                    {desktopMenuOptions.length > 0 && (
                                        <PopOverMenu
                                            horizontalEllipsis={false}
                                            menuItems={desktopMenuOptions}
                                            onSelected={this.onSelected}
                                            anchorClass="pop-over-menu-nchor"
                                            data-testid={dataTestId && `${dataTestId}.mobile.options-menu`}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${forceCardView || (force && force.cardView) ? 'd-none' : 'd-none d-md-block'}`}>
                        <div className="list-view">
                            <div className="content row">
                                <div className="col-9">
                                    <div className="rank" data-testid={dataTestId && `${dataTestId}.desktop.rank`}>{index}</div>
                                    <div className="flex-2">
                                        {gameType === 'singles'
                                            ? (
                                                <div className="players-wrapper">
                                                    <div className="player-input">
                                                        {team1 && (
                                                            <BackgroundImage
                                                                baseUrl={'/v1/club/'}
                                                                defaultImage={'/img/utr-ball--teal.svg'}
                                                                images={team1.clubProfileImages}
                                                                imageType={'profile'}
                                                                parentStylesClass={'team-logo'}
                                                            />
                                                        )}
                                                        <PlayerSelectComponent
                                                            drawFormatType={singlesDraw.drawFormatType}
                                                            match={matchObj}
                                                            playerOptions={team1Players}
                                                            playersDict={playersDict}
                                                            utrType={utrType}
                                                            allowPlayerChange={true}
                                                            showBye={false}
                                                            position="position1"
                                                            onSelect={this.playerSelect}
                                                            showTeamName={true}
                                                            teamName={team1.isCollege ? (team1.shortName || team1.displayName) : team1.displayName}
                                                            warnBeforePlayerChange={matchObj.result ? 'Changing a player will reset the scores.' : false}
                                                            doNotMask={false}
                                                            sportTypeId={sportTypeId}
                                                            data-testid={dataTestId && `${dataTestId}.desktop.singles-position1-player-select`}
                                                        />
                                                    </div>
                                                    <div className="player-input">
                                                        {team2 && (
                                                            <BackgroundImage
                                                                baseUrl={'/v1/club/'}
                                                                defaultImage={'/img/utr-ball--teal.svg'}
                                                                images={team2.clubProfileImages}
                                                                imageType={'profile'}
                                                                parentStylesClass={'team-logo'}
                                                            />
                                                        )}
                                                        <PlayerSelectComponent
                                                            drawFormatType={singlesDraw.drawFormatType}
                                                            match={matchObj}
                                                            playerOptions={team2Players}
                                                            playersDict={playersDict}
                                                            utrType={utrType}
                                                            allowPlayerChange={true}
                                                            showBye={false}
                                                            position="position2"
                                                            onSelect={this.playerSelect}
                                                            showTeamName={true}
                                                            teamName={team2.isCollege ? (team2.shortName || team2.displayName) : team2.displayName}
                                                            warnBeforePlayerChange={matchObj.result ? 'Changing a player will reset the scores.' : false}
                                                            doNotMask={false}
                                                            sportTypeId={sportTypeId}
                                                            data-testid={dataTestId && `${dataTestId}.desktop.singles-position2-player-select`}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                            : (
                                                <div className="players-wrapper">
                                                    <DoublesPlayerSelectComponent
                                                        drawFormatType={doublesDraw.drawFormatType}
                                                        match={matchObj}
                                                        playerOptions={team1Players}
                                                        playersDict={playersDict}
                                                        teamsDict={teamsDict}
                                                        teams={teams}
                                                        clubProfileImages={team1 && team1.clubProfileImages}
                                                        utrType={utrType}
                                                        allowPlayerChange={true}
                                                        showBye={false}
                                                        position="position1"
                                                        onSelect={this.teamSelect}
                                                        showTeamName={true}
                                                        teamName={team1.isCollege ? (team1.shortName || team1.displayName) : team1.displayName}
                                                        warnBeforePlayerChange={matchObj.result ? 'Changing a player will reset the scores.' : false}
                                                        sportTypeId={sportTypeId}
                                                        data-testid={dataTestId && `${dataTestId}.desktop.doubles-position1-player-select`}
                                                    />
                                                    <DoublesPlayerSelectComponent
                                                        drawFormatType={doublesDraw.drawFormatType}
                                                        match={matchObj}
                                                        playerOptions={team2Players}
                                                        playersDict={playersDict}
                                                        teamsDict={teamsDict}
                                                        teams={teams}
                                                        clubProfileImages={team2 && team2.clubProfileImages}
                                                        utrType={utrType}
                                                        allowPlayerChange={true}
                                                        showBye={false}
                                                        position="position2"
                                                        onSelect={this.teamSelect}
                                                        showTeamName={true}
                                                        teamName={team2.isCollege ? (team2.shortName || team2.displayName) : team2.displayName}
                                                        warnBeforePlayerChange={matchObj.result ? 'Changing a player will reset the scores.' : false}
                                                        sportTypeId={sportTypeId}
                                                        data-testid={dataTestId && `${dataTestId}.desktop.doubles-position2-player-select`}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                    <div className={`flex-1`} />
                                    <div className={`flex-1 text-right`}>
                                        {hasResult
                                            ? (
                                                <React.Fragment>
                                                    <DisplayScoreComponent match={matchObj} position="position1" playersDict={playersDict} teamsDict={teamsDict} data-testid={dataTestId && `${dataTestId}.desktop.position1-score`} />
                                                    <DisplayScoreComponent match={matchObj} position="position2" playersDict={playersDict} teamsDict={teamsDict} data-testid={dataTestId && `${dataTestId}.desktop.position2-score`} />
                                                </React.Fragment>
                                            )
                                            : (
                                                <button
                                                    type="button"
                                                    className="btn btn-default btn-small mr16"
                                                    disabled={disablePostScoreButton}
                                                    onClick={this.handlePostScore}
                                                    data-testid={dataTestId && `${dataTestId}.desktop.score-btn`}
                                                >Score
                                                </button>
                                            )}
                                    </div>
                                </div>
                                <div className="col-3 bl jcsb">
                                    <div className="flex-column date-round">
                                        {/* <div>{(round ? <span>{round.name} &middot; </span> : '')}{formatMatchDateWithOffset(date, this.props.timeZoneValue)}</div> */}
                                        <div data-testid={dataTestId && `${dataTestId}.desktop.event-date`}>{eventDate}</div>
                                        <div data-testid={dataTestId && `${dataTestId}.desktop.team-name`}>{team2.name}</div>
                                    </div>
                                    <div className="options-container align-self-center">
                                        {desktopMenuOptions.length > 0 && (
                                            <PopOverMenu
                                                horizontalEllipsis={false}
                                                menuItems={desktopMenuOptions}
                                                onSelected={this.onSelected}
                                                anchorClass="pop-over-menu-nchor"
                                                data-testid={dataTestId && `${dataTestId}.desktop.options-menu`}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={`card-overlay`}>
                        <div className={`saving`} data-testid={dataTestId && `${dataTestId}.saving`}><i className="fas fa-circle-notch fa-spin" /> Saving...</div>
                    </div>
                </div>
                {this.state.showDeletePopUp && (
                    <Popup
                        className="popup-md"
                        data-testid="modal.dual-match-delete"
                        onCloseClick={() => {
                            this.setState({
                                showDeletePopUp: false,
                            });
                        }}
                        config={{
                            fullScreen: false,
                            noPadding: true,
                            gradient: true,
                            scrollable: false,
                        }}
                    >
                        <div className="popup-section p24 pt0 pb0">
                            <h5 className="text-dark mb0" data-testid="modal.dual-match-delete.title">
                                Delete score
                            </h5>
                        </div>
                        <div className="popup-section p24 mb32 text-dark">
                            <p data-testid="modal.dual-match-delete.description">
                                {`Are you sure you want to delete this score for ${this.getMatchText(players)} on ${formatMatchDateWithOffset(date, this.props.timeZoneValue, false, true)}. This action cannot be reversed.`}
                            </p>
                            <div className="mt24">
                                <div className="row">
                                    <div className={`col-md-6`}>
                                        <button
                                            type="button"
                                            className="btn btn-default btn-default text-uppercase btn-block"
                                            onClick={() => {
                                                this.setState({
                                                    showDeletePopUp: false,
                                                });
                                            }}
                                            data-testid="modal.dual-match-delete.cancel-btn"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className={`col-md-6`}>
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-default text-uppercase btn-block"
                                            onClick={() => {
                                                this.setState({
                                                    showDeletePopUp: false,
                                                });
                                                this.props.deleteUserScore(this.props.id);
                                            }}
                                            data-testid="modal.dual-match-delete.delete-btn"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}
            </React.Fragment>
        );
    }
}

DualMatchCardEdit.defaultProps = {
    timeZoneValue: 'UTC',
    showVerified: true,
    'data-testid': null,
};

function mapDispatchToProps(dispatch) {
    return {
        setPlayerPostedMatch: (data) => dispatch(actions.setPlayerPostedMatch(data)),
        resendInvites: (resultId) => dispatch(actions.resendInvites(resultId)),
        deleteUserScore: (resultId) => dispatch(actions.deleteUserScore(resultId)),
        acceptOrRejectScore: (resultId, acceptOrReject) => dispatch(actions.acceptOrRejectScore(resultId, acceptOrReject)),
        showErrorPopup: (message, error) => dispatch(showErrorPopup({ message, error })),
    };
}

export default withRouter(withAuth(connect(null, mapDispatchToProps)(DualMatchCardEdit)));
